import { css } from "@emotion/react";
import React, { CSSProperties } from "react";
import { ConsiderOptionHeadline } from "./ConsiderOptionHeadline";
import { IconsAndTextsItemType } from "@swo/storefront";
import { SORichTextRenderer } from "../../../../components/_shared-components/so-rich-text";
import { FONTS, fontSize } from "../../../../styles/fonts";
import { CSS_MQ } from "../../../../styles/breakpoints";
import { CSS_COLORS } from "../../../../styles/styles-css-variables";
import { T } from "../../../../components/T";

export const ConsiderOption: React.FC<{
  item: IconsAndTextsItemType;
  className?: string;
  style?: CSSProperties;
  ref?: any;
}> = ({ item, className, style, ref }) => {
  return (
    <div
      ref={ref}
      css={css`
        width: 100%;
        height: 100%;

        background-color: ${CSS_COLORS.White};

        border-radius: 20px;
        padding: 15px 20px;

        ${CSS_MQ.atLeastMd} {
          border-radius: 40px;
          padding: 50px 100px;
        }
      `}
    >
      <div
        className={className}
        style={style}
        css={css`
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        `}
      >
        <ConsiderOptionHeadline title={<T>{item.headline}</T>} svgLink={item.icon.url} />

        <hr
          css={css`
            width: 20px;
            height: 1px;

            margin-top: 20px;
            margin-bottom: 16px;
            ${CSS_MQ.atLeastMd} {
              margin-top: 40px;
              margin-bottom: 20px;
            }
            margin-left: 0;

            border: none;
            background-color: ${CSS_COLORS.Black};
          `}
        />

        {item.text && (
          <div
            css={[
              FONTS.SwarovskiFutura300,
              fontSize.x25,
              css`
                color: ${CSS_COLORS.Black};
                text-align: left;

                p {
                  word-break: break-word;
                }

                a {
                  color: var(--so-green);
                }
              `,
            ]}
          >
            <SORichTextRenderer richText={item.text} options={"default"} />
          </div>
        )}
      </div>
    </div>
  );
};
